/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Brands Web API v2
 * OpenAPI spec version: v2
 */

export type AuthErrorResponseSchemaCode = typeof AuthErrorResponseSchemaCode[keyof typeof AuthErrorResponseSchemaCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthErrorResponseSchemaCode = {
  StepUpRequired: 'StepUpRequired',
  TwoFactorRequired: 'TwoFactorRequired',
  EnforcementActive: 'EnforcementActive',
  MethodChangeNotAllowed: 'MethodChangeNotAllowed',
  NoTwoFactorMethod: 'NoTwoFactorMethod',
  MethodNotSetUp: 'MethodNotSetUp',
  EmailRetired: 'EmailRetired',
  AuthenticatorUnavailable: 'AuthenticatorUnavailable',
  SupportPhonePinned: 'SupportPhonePinned',
  CodeAlreadyUsed: 'CodeAlreadyUsed',
  InvalidCode: 'InvalidCode',
  RecoveryCodesExhausted: 'RecoveryCodesExhausted',
  RateLimited: 'RateLimited',
  ImpersonatedSession: 'ImpersonatedSession',
  ResetPasswordRequired: 'ResetPasswordRequired',
  InvalidPhoneNumber: 'InvalidPhoneNumber',
  RequestFailed: 'RequestFailed',
  PasswordMismatch: 'PasswordMismatch',
  InvalidPassword: 'InvalidPassword',
  IncorrectPassword: 'IncorrectPassword',
} as const;
